/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "Stripe",
            "endpoint": "https://gqgtt4m9l1.execute-api.us-east-1.amazonaws.com/master",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://s3obyuvitjhz5emsjvkqtrdkoi.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-jym4gitb7fbndd4yti3xxq6phe",
    "aws_cognito_identity_pool_id": "us-east-1:ad9163d2-d435-4c9a-a2de-1ded9691d341",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_wwEw0txnc",
    "aws_user_pools_web_client_id": "4e35ualg3ean970mcjlvq5o8ap",
    "oauth": {
        "domain": "transferthoughtcdbbc19c-cdbbc19c-master.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://scenario.transferthought.com/",
        "redirectSignOut": "https://scenario.transferthought.com/signin/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "transferthought1382d681d5a54845b17b150d2dc3613621307-master",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "predictions": {
        "convert": {
            "speechGenerator": {
                "region": "us-east-1",
                "proxy": false,
                "defaults": {
                    "VoiceId": "Joanna",
                    "LanguageCode": "en-US"
                }
            },
            "transcription": {
                "region": "us-east-1",
                "proxy": false,
                "defaults": {
                    "language": "en-US"
                }
            }
        }
    }
};


export default awsmobile;
